import type {
    PubsubPublishRecord,
    GetCoastContentItemQueryVariables,
    GetCoastPreviousNextFeedQueryVariables,
} from "@ihr-radioedit/inferno-webapi";
import { getSdk, sdkOpts } from "@ihr-radioedit/inferno-core";

const sdk = getSdk(sdkOpts());

export const getCoastPreviousNextFeed = (query: GetCoastPreviousNextFeedQueryVariables) =>
    sdk!.GetCoastPreviousNextFeed.queryAsPromise(query).then(r => r.data?.pubsub?.query?.items || []);

export const getGetCoastContentItem = (query: GetCoastContentItemQueryVariables) =>
    sdk!.GetCoastContentItem.queryAsPromise(query).then(r => (r.data?.pubsub?.get || {}) as PubsubPublishRecord);
